import React from 'react';
import styled from 'styled-components';

import Footer from './Footer';
import HeroImage from './HeroImage';
import Products from './Products';
import Title from './Title';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 46px;
`;

const Row = styled.div`
  display: flex;
  padding: 10px;
  margin-bottom: 10px;
  width: 100%;

  @media (max-width: 1049px) {
    display: block;
  }
`;

export default ({ title, tagLine, products, heroImageURL, footerText, downloadURL }) => (
  <Wrapper>
    <Row>
      <HeroImage url={heroImageURL} />
    </Row>
    <Title title={title} tagLine={tagLine} />
    <Row>
      <Products products={products} />
    </Row>
    <Footer footerText={footerText} downloadURL={downloadURL} />
  </Wrapper>
);
